// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search .container[data-v-2c23665c]{margin-left:auto;margin-right:auto}.search__list[data-v-2c23665c]{width:100%}@media (min-width:960px){.search__list[data-v-2c23665c] .list__job{width:50%;padding-top:.5rem;padding-bottom:.5rem}.search__list[data-v-2c23665c] .list__job .jc{max-width:none}}", ""]);
// Exports
module.exports = exports;
